export const transformPostNordParcelProductId = shippingOption => {
    //This code should be safe to remove 2021-06 since all drafts + templates containing old ids should have been removed by then
    if (shippingOption.type !== 'PostNordParcel') {
        return;
    }

    if (shippingOption.productId === undefined) {
        return;
    }

    const validProductIds = [10, 20, 30, 40, 50, 60, 70, 80, 90];
    const productIdsToTransform = [2000, 3000, 3500, 4000, 5000, 5500, 6000];

    if (validProductIds.indexOf(shippingOption.productId) !== -1) {
        return;
    }

    if (productIdsToTransform.indexOf(shippingOption.productId) === -1) {
        shippingOption.productId = undefined;
        return;
    }

    const compositeKey = `${shippingOption.productId},${shippingOption.weight *
        1000}`;

    const map = {
        '2000,250': 10,
        '2000,500': 20,
        '2000,1000': 30,
        '3000,2000': 40,
        '3500,3000': 50,
        '4000,5000': 60,
        '5000,10000': 70,
        '5500,15000': 80,
        '6000,20000': 90
    };

    shippingOption.productId = map[compositeKey];
};
